import React from "react";
import Table from "../CommonTable";
import { useMediaQuery } from "react-responsive";
import { CONSTANTS } from "../../shared/constants";
import { store } from "../../redux/store";
import { setIsGlobalModalOpen, setModalData } from "../../redux/modal";

const ProcessCard = ({ record }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  return (
    <div className="process-card">
      <Table rows={[record]} isMobile={isMobile} />
      <BidInfo record={record} />
    </div>
  );
};

const BidInfo = ({ record }) => {
  var imageBasePath =
    window.location.protocol + "//" + window.location.host + "/";
  const [value, setValue] = React.useState(record.currentPrice);

  const handleIncrement = () => {
    setValue((prevValue) => prevValue + 1000);
  };

  const handleDecrement = () => {
    setValue((prevValue) => prevValue - 1000);
  };

  return (
    <div className="bid-info">
      <div className="prices">
        <div>Current Price：{record.currentPrice.toLocaleString()} Yen</div>
        <div>Total Price：{record.totalPrice.toLocaleString()} Yen</div>
        <div>Bid Price：{record.bidPrice.toLocaleString()} Yen</div>
        <div>Total Price：{record.totalPrice.toLocaleString()} Yen</div>
      </div>
      <div className="others">
        {CONSTANTS.BID_STATUS.GOT_HIGHER_BID === record.status ? (
          <div className="higher-bidder">
            There is a higher bidder than you.
          </div>
        ) : (
          <div className="not higher-bidder">
            There is no higher bidder than you.
          </div>
        )}
        <Counter
          value={value}
          handleDecrement={handleDecrement}
          handleIncrement={handleIncrement}
          setValue={setValue}
        />

        <button
          onClick={async () => {
            store.dispatch(setIsGlobalModalOpen(true));
            store.dispatch(
              setModalData({
                auctionType: CONSTANTS.AUCTION_TYPES.LIVE,
                currentPrice: record.currentPrice,
                vehicleId: record.vehicle._id,
              })
            );
          }}
          className="bid-btn round"
        >
          <img
            src={imageBasePath + "hammer.png"}
            alt={imageBasePath + "hammer.png"}
          />
          Bid
        </button>
      </div>
    </div>
  );
};

const Counter = ({ handleDecrement, handleIncrement, value, setValue }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "center" : "auto",
        justifyContent: "space-between",
        marginTop: 40,
      }}
    >
      <div className="textual">
        <h2>Bid Amount</h2>
        <span>Bid Unit Price (1000 Yen)</span>
      </div>
      <div className="counter">
        <div className="input-box">
          <input
            type="number"
            className="hide-arrows"
            value={value}
            onChange={(e) => setValue(parseInt(e.target.value))}
          />
          Yen
        </div>
        <div className="count-btns">
          <button onClick={handleIncrement}>
            <i className="fa fa-angle-up"></i>
          </button>
          <button onClick={handleDecrement}>
            <i className="fa fa-angle-down"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProcessCard;
